import script from "./ListProposals.vue?vue&type=script&setup=true&lang=js"
export * from "./ListProposals.vue?vue&type=script&setup=true&lang=js"

import "./ListProposals.vue?vue&type=style&index=0&id=14e3c767&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14e3c767"]])

export default __exports__